export enum MetricIndex {
  Unindexed = 'unindexed',
  Aqi = 'aqi',
}
